import { connect } from 'react-redux';
import HeroBanner from './hero_banner';

const mapStateProps = () => ({});

export default connect(
  mapStateProps
)(HeroBanner);
